import * as React from "react";

function FlagEn(props) {
  return (
    <svg
      viewBox="0 0 16.29 9.28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      {...props}
    >
      <g>
        <rect y="0.01" fill="currentColor" width="7.23" height="5.22" />
        <rect x="8.37" fill="currentColor" width="7.92" height="0.88" />
        <rect x="8.37" y="2.1" fill="currentColor" width="7.92" height="0.88" />
        <rect x="8.37" y="4.2" fill="currentColor" width="7.92" height="0.88" />
        <rect
          x="0.03"
          y="6.3"
          fill="currentColor"
          width="16.26"
          height="0.88"
        />
        <rect
          x="0.03"
          y="8.4"
          fill="currentColor"
          width="16.26"
          height="0.88"
        />
      </g>
    </svg>
  );
}

export default FlagEn;
